import React from "react"
import { BACKEND_APIS } from "@constants"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { array, object } from "yup"
import { WebSuppliersAutocomplete } from "@components"


export default function ReportWebSuppliersField() {
	const {
		filterWebSuppliers,
		setFilterWebSuppliersInfo,
		error
	} = useReportFormInfo(reportFormData.peek().filterWebSuppliers, "filterWebSuppliers", object({ filterWebSuppliers: array().nullable() }))

	return <WebSuppliersAutocomplete
		value={filterWebSuppliers}
		onChange={e => setFilterWebSuppliersInfo(e.target.value)}
		error={error}
		urlAjax={`${BACKEND_APIS.MASTER_DATA}/options/web_suppliers`}
	/>
}